const fadedNavbar = () => {
  let nav = document.querySelector("nav.navbar");

  if (window.scrollY >= 150) {
    nav.classList.add("navbar--sticky");
  }

  setTimeout(() => {
    if (
      nav.classList.contains("opacity-0") &&
      nav.classList.contains("-translate-y-full")
    ) {
      nav.classList.remove("opacity-0", "-translate-y-full");
    }
  }, 150);

  setTimeout(() => {
    if (nav.classList.contains("duration-1000")) {
      nav.classList.remove("duration-1000");
    }
    if (!nav.classList.contains("duration-300")) {
      nav.classList.add("duration-300");
    }
  }, 175);
};

module.exports = fadedNavbar;
